import { useMemo } from 'react';
import { PersonalShelf } from '@jwp/ott-common/src/constants';
import type { Content } from '@jwp/ott-common/types/config';

import type { UsePlaylistResult } from './usePlaylists';

export const useShelfListStatus = (playlists: UsePlaylistResult, rows: Content[], rowsToLoad: number) => {
  const allLoadedEmpty = useMemo(
    () => playlists.slice(0, rowsToLoad).every(({ data, error, isSuccess }) => (isSuccess || error) && !data?.playlist?.length),
    [playlists, rowsToLoad],
  );

  // If all playlists are empty (most probably due to geo restrictions), we show an empty shelves error
  const allPlaylistsEmpty = useMemo(() => playlists.every(({ data, isSuccess }) => isSuccess && !data?.playlist?.length), [playlists]);

  const allPlaylistsError = useMemo(
    () =>
      playlists.every((playlist, index) => {
        const { type } = rows[index];
        // Personal shelves never error, so exclude them from the comparison
        return type === PersonalShelf.Favorites || type === PersonalShelf.ContinueWatching || !playlist.isSuccess;
      }),
    [playlists, rows],
  );

  return { allLoadedEmpty, allPlaylistsEmpty, allPlaylistsError };
};

export default useShelfListStatus;
